import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Sweet Potato Casserole',
  source: 'https://www.seriouseats.com/sweet-potato-casserole-marshmallow-recipe',
  totalTime: time(3, 15),
  servings: 8,
  tags: { type: 'side' },
  vessels: { main: { kind: 'baking-dish', width: 8, height: 8 } },
  ingredients: [
    { name: 'sweet potatoes', quantity: '6', unit: 'lb' },
    { name: 'unsalted butter', quantity: '8', unit: 'tbsp' },
    { name: 'fresh thyme', quantity: '8', unit: 'sprigs', customUnit: true,
      note: 'or sage',
    },
    { name: 'fresh ginger', quantity: '1', unit: 'tbsp',
      note: 'finely grated',
    },
    { name: 'buttermilk', quantity: '1/4', unit: 'cup',
      note: 'or sour cream',
    },
    { name: 'kosher salt' },
    { name: 'mini marshmallows', quantity: '2', unit: 'cup' },
  ],
  directions: [
    {
      title: 'Slow roast potatoes',
      bullets: [
        "Wrap {sweet potatoes} in 2 sealed heavy-duty foil pouches",
        "Transfer pouches to rimmed baking sheet",
        "Bake at {!300F} on middle rack ~2h, until thin skewer meets no resistance",
        "Cool until handleable",
      ],
    },
    {
      title: 'Brown butter & herbs',
      bullets: [
        "In medium saucepan over medium-low heat, melt {unsalted butter}, swirling gently, until pale golden brown with nutty smell",
        "Add {fresh thyme}",
        "Swirl herbs in brown butter off-heat until frizzled"
      ],
    },
    {
      title: 'Mash & season',
      bullets: [
        "Peel cooled potatoes",
        "Transfer flesh to large bowl",
        "Beat ~2 min until smooth & fluffy",
        "Pour brown butter into potatoes, discarding frizzled herbs",
        "Beat in {fresh ginger}, then beat in {buttermilk}",
        "Season to taste with {kosher salt}",
      ],
    },
    {
      title: 'Assemble',
      perVessel: true,
      bullets: [
        "Scrape mashed potatoes into {vessel}, smoothing surface with rubber spatula",
      ],
    },
    {
      title: 'Bake & top',
      bullets: [
        "Bake at {!375F} ~30 min, until heated through",
        "Top with {mini marshmallows}",
        "Bake at {!475F} ~3 min, until marshmallows are melted & lightly browned — watch closely"
      ],
    },
  ],
};

export default recipe;
